import React from 'react';
import { ShieldCheck, Anchor, Map, DollarSign, HeadphonesIcon, Clock } from 'lucide-react';
export function WhyChooseUs() {
  const reasons = [{
    icon: ShieldCheck,
    title: 'Fully Insured',
    desc: 'Comprehensive cargo insurance included with every RV hauling quote for total peace of mind.'
  }, {
    icon: Anchor,
    title: 'Experienced Haulers',
    desc: 'Our drivers specialize exclusively in RV transport and motorhome shipping, handling RVs of all sizes.'
  }, {
    icon: Map,
    title: 'Nationwide Coverage',
    desc: 'Door-to-door RV movers operating across all 50 states, ensuring your vehicle arrives safely.'
  }, {
    icon: DollarSign,
    title: 'Transparent Pricing',
    desc: 'No hidden fees, no bait-and-switch. The RV shipping quote you get is the price you pay.'
  }, {
    icon: HeadphonesIcon,
    title: '24/7 Support',
    desc: 'Dedicated logistics coordinators available around the clock to track your RV transport.'
  }, {
    icon: Clock,
    title: 'On-Time Delivery',
    desc: 'We respect your schedule. Reliable transit times and consistent communication throughout the move.'
  }];
  return <section className="py-20 bg-white" data-id="element-319">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-320">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-321">
          <h2 className="text-3xl md:text-4xl font-black text-brand-navy mb-4" data-id="element-322">
            Why Choose LynJones Logistics?
          </h2>
          <p className="text-lg text-slate-600" data-id="element-323">
            As a premier RV transport company, we set the standard for safety,
            reliability, and customer service in the RV logistics industry.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-324">
          {/* Reasons Grid */}
          <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-325">
            {reasons.map((reason, index) => <div key={index} className="p-6 rounded-2xl border border-slate-100 bg-slate-50 hover:shadow-lg transition-shadow duration-300" data-id="element-326">
                <div className="w-12 h-12 bg-brand-navy/5 rounded-xl flex items-center justify-center mb-4" data-id="element-327">
                  <reason.icon className="w-6 h-6 text-brand-red" data-id="element-328" />
                </div>
                <h3 className="text-xl font-bold text-brand-navy mb-2" data-id="element-329">
                  {reason.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-330">
                  {reason.desc}
                </p>
              </div>)}
          </div>

          {/* Credibility Photo */}
          <div className="lg:col-span-4 h-full" data-id="element-331">
            <div className="relative rounded-2xl overflow-hidden shadow-xl h-full min-h-[400px] lg:min-h-full" data-id="element-332">
              <img src="https://images.unsplash.com/photo-1523987355523-c7b5b0dd90a7?q=80&w=800&auto=format&fit=crop" alt="RV securely transported on a highway" className="absolute inset-0 w-full h-full object-cover" data-id="element-333" />
              <div className="absolute inset-0 bg-brand-navy/20" data-id="element-334"></div>
              <div className="absolute top-6 right-6 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-lg shadow-sm border border-white/20" data-id="element-335">
                <p className="text-brand-navy font-bold text-sm flex items-center gap-2" data-id="element-336">
                  <ShieldCheck className="w-4 h-4 text-brand-red" data-id="element-337" />
                  Fully Insured Transport
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}